module.exports = __webpack_public_path__ + "static/media/key-icon.858f0927.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/key-icon.svg
// module id = 241
// module chunks = 7